import React from "react";
import {
  Divider,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { StarRate as StarRateIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { convertToPercentage } from "utils/mathUtils";

type SuccessRateEvaluationProps = {
  data: {
    efficiencyRate: number;
    dealerEfficiencyRate: number;
    evaluation: number;
  };
};

const SuccessRateEvaluation = ({
  data: { evaluation, efficiencyRate, dealerEfficiencyRate },
}: SuccessRateEvaluationProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const media = useMediaQuery(theme.breakpoints.between("sm", "lg"));

  return (
    <Grid
      container
      columns={12}
      columnSpacing={1}
      display="flex"
      justifyContent="space-between"
      gap={1}
    >
      <Grid item>
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          {t("efficiencyRate")} (Geral)
        </Typography>
        <Typography variant="h4" component="div">
          {convertToPercentage(efficiencyRate)}
        </Typography>
      </Grid>
      <Divider
        orientation={media ? "horizontal" : "vertical"}
        variant="fullWidth"
        flexItem
      />
      <Grid item>
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          {t("efficiencyRate")} (Revenda)
        </Typography>
        <Typography variant="h4" component="div">
          {convertToPercentage(dealerEfficiencyRate)}
        </Typography>
      </Grid>
      <Divider
        orientation={media ? "horizontal" : "vertical"}
        variant="fullWidth"
        flexItem
      />
      <Grid item>
        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
          {t("averageUserRating")}
        </Typography>
        <Typography variant="h4" component="div">
          {evaluation.toLocaleString("pt-BR")}
          <StarRateIcon htmlColor="#FAAF00" />
        </Typography>
      </Grid>
    </Grid>
  );
};

export default SuccessRateEvaluation;
